import action from '../commons/loginActionStatus';

export const authSignInRequestAction = (phone, platform, countryCode) => {
    return {
        type: action.SIGNIN_REQUEST,
        status: 'SIGNIN_REQUEST',
        requestState: true,
        payload: {
            phone,
            platform,
            countryCode
        },
    };
};

export const authSignInSuccessAction = (result, userAttributes) => {
    return {
        type: action.SIGNIN_SUCCESS,
        status: 'success from sign in',
        result,
        requestState: false,
        userAttributes,
    };
};

export const authSignInFailureAction = (error) => {
    return {
        type: action.SIGNIN_FAILURE,
        status: 'failure',
        error,
        requestState: false,
    };
};

// -------verify sign in ---------

export const authVerifySignInRequestAction = (phone, platform, otp, countryCode ) => {
    return {
      type: action.VERIFY_SIGNIN_REQUEST,
      requestState: true,
      payload: {
        phone,
        platform,
        otp,
        countryCode,
      },
    };
  };
  export const authVerifySignInSuccessAction = (userAttributes) => {
    return {
      type: action.VERIFY_SIGNIN_SUCCESS,
      status: 'OTP Verificaiton Sucessfull',
      userAttributes,
      requestState: false,
    };
  };
  
  export const authVerifySignInFailureAction = (error) => {
    return {
      type: action.VERIFY_SIGNIN_FAILURE,
      status: 'failure',
      error,
      requestState: false,
    }
}

// logout 

export const authLogoutRequestAction = () => {
  return {
    type: action.SIGNOUT_REQUEST,
    requestState: true,
  };
};
export const authLogoutSuccessAction = () => {
  return {
    type: action.SIGNOUT_SUCCESS,
    status: 'Signout Sucessfully',
    requestState: false,
  };
};

export const authLogoutFailureAction = (error) => {
  return {
    type: action.SIGNOUT_FAILURE,
    status: 'failure',
    error,
    requestState: false,
  }
}

// update hospital info

export const changeHospitalRequestAction = (hospitalId) => {
  return {
    type: action.CHANGE_HOSPITAL_REQUEST,
    requestState: true,
    payload: {
      hospitalId
    },
  };
};
export const changeHospitalSuccessAction = (userAttributes) => {
  return {
    type: action.CHANGE_HOSPITAL_SUCCESS,
    status: 'hospital Changed Successfully',
    userAttributes,
    requestState: false,
  };
};

export const changeHospitalFailureAction = (error) => {
  return {
    type: action.CHANGE_HOSPITAL_FAILURE,
    status: 'failure',
    error,
    requestState: false,
  }
}

